import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=1173c3f4&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=1173c3f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173c3f4",
  null
  
)

export default component.exports